import React from 'react';
import styled from 'styled-components';

const Styled = styled.div`
  margin: 0 15px;
  border-bottom: 1px solid #dddddd;
`;

const Cleaner = styled.div`
  clear: both;
  visibility: hidden;
`;

const BoxHeader = ({ children, style }) => {
  return (
    <Styled style={style}>
      {children}
      <Cleaner />
    </Styled>
  );
};

export default BoxHeader;
